import { RolesState } from '../types';
import { DELETE_DIALOG_DATA } from '@shared/dialogs/types';

export const FeatureKey = 'roles';

export const DEFAULT_ROLES_STORE: RolesState = {
  permissionList: {
    permissions: [],
  },
  rolesList: {
    data: [],
    total: 0,
  },
};

export const DEFAULT_DELETE_ROLE_DATA: Partial<DELETE_DIALOG_DATA> = {
  buttons: {
    cancelButtonText: 'Cancel',
    cancelColor: 'tertiary',
    deleteButtonText: 'Delete',
    primaryColor: 'primary-warn',
  },
  errorText: 'Reason for deletion field is required.',
  formControlName: 'delete',
  label: 'Reason for deletion',
  title: 'Delete User Role',
};

export const DEFAULT_ELIGIBILITY_DATA: Partial<DELETE_DIALOG_DATA> = {
  buttons: {
    cancelButtonText: 'Cancel',
    cancelColor: 'tertiary',
    deleteButtonText: 'Done',
    primaryColor: 'primary',
  },
  errorText:
    'Unable to delete this User Role. One or more users are assigned to this User Role.',
  title: 'Unable to delete',
};

export const STUDY_LEVEL_PERMISSIONS = new Set<string>([
  'study submission',
  'study detail',
  'study correspondence',
  'study team',
]);
